// extracted by mini-css-extract-plugin
export default {"container":"CodeEditor_container__7b0RI","tag":"CodeEditor_tag__nBlUZ"};